"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgRulerFilled(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M25.45 17.96l-3.74 3.74-1.42-1.41 3.74-3.74-3.58-3.59-3.74 3.74-1.42-1.41 3.74-3.74-3.58-3.59-3.74 3.74-1.42-1.41 3.74-3.74-4.86-4.86-7.6 7.29 21.41 21.41 7.61-7.29-5.14-5.14z" })));
}
exports.default = SvgRulerFilled;
//# sourceMappingURL=RulerFilled.js.map